<template>
  <div class="fullLoader">
    <div>
      <img src="images/checkout-general-loading.gif" />
    </div>
  </div>
</template>

<style lang="scss">
.fullLoader {
  div {
    background: #fff;
    width: 200px;
    height: 195px;
    padding: 0 25px 25px;
    box-shadow: 5px 10px 25px rgba(0, 0, 0, 0.3);
    border-radius: 15px;
  }
}
</style>
